// Phase 129 Plan 04 Task 1 — cn() helper (shadcn convention).
// Mirrors frontend/src/lib/utils.ts verbatim. Per shadcn conventions, each
// package keeps its own copy of cn() rather than sharing through @hookmyapp/shared
// — UI primitives and styling tokens differ per surface (frontend uses base-nova
// presets, web/ uses Meta-Store-inspired DESIGN.md tokens).
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
